import React from "react";

//
import { logoutUser } from "../../redux/features/user/actions";

//
import { Modal, Button, Row, Col } from "react-bootstrap";

function LogoutModal({show, setShow}) {
  return (
    <Modal centered show={show} onHide={() => setShow(false)} id="logout-modal">
      <Modal.Header className="align-items-center">
        <h5>Are you sure wanna logout?</h5>
      </Modal.Header>
      <Modal.Body>
        <Row className="actions">
          <Col xs={6}>
            <div
              className="text-danger text-center pointer"
              onClick={() => logoutUser()}
            >
              Logout now
            </div>
          </Col>

          <Col xs={6}>
            <Button
              variant="info"
              size="lg"
              className="w-100"
              onClick={() => setShow(false)}
            >
              Go Back
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default LogoutModal;
